import { Layout } from '@components/Layout';
import PermissionGate from '@components/upercut-permissions/PermissionGate';
// import PricingTableCreateModule from '@modules/PricingTable/PricingTableCreate';
import PricingTableDetailModule from '@modules/PricingTable/PricingTableDetail';
// import PricingTableEditModule from '@modules/PricingTable/PricingTableEdit';
import PricingTableListModule from '@modules/PricingTable/PricingTableList';
import { Route, Routes } from 'react-router-dom';

const PricingTableManagementPage = () => {
    return (
        <Layout
            breadcrumbs={[
                { label: 'Tableau de bord', href: '/', value: 'dashboard' },
                { label: 'Grilles tarifaires', href: '/pricing-tables', value: 'pricing-tables' },
            ]}
            heading="Gestion des grilles tarifaires"
        >
            <Routes>
                <Route
                    path="/"
                    element={
                        <PermissionGate permission="pricing:read">
                            <PricingTableListModule />
                        </PermissionGate>
                    }
                />
                {/* <Route
                    path="/create"
                    element={
                        <PermissionGate permission="analytics:manage">
                            <PricingTableCreateModule />
                        </PermissionGate>
                    }
                /> */}
                {/* <Route
                    path="/edit/:id"
                    element={
                        <PermissionGate permission="analytics:manage">
                            <PricingTableEditModule />
                        </PermissionGate>
                    }
                /> */}
                <Route
                    path="/detail/:id"
                    element={
                        <PermissionGate permission="pricing:read">
                            <PricingTableDetailModule />
                        </PermissionGate>
                    }
                />
            </Routes>
        </Layout>
    );
};

export default PricingTableManagementPage;
